module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("1940–1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("October 1940: On the Road to the Fox Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("The Fox Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Later That Night: The Commandant’s Underwear")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Same Night: Ingrid’s Diary")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Few Days Later: Waiting for the Ferry")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Soccer Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Intrusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Bakery")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Café")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Week Later: Soccer Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Day: Jotunheimen")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1940: First Assignment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter 1942: Ingrid’s Diary")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1942: The Blank Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Encounter")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1942: The Prisoners")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Thing”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 4, 1942: The Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Winter 1942: Ingrid’s Diary: The Secret")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Hats")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ski Contest")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ski Contest")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Joiner")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1943: The Rabbit Plays Harmonica")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Day: Just Before Dawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bicycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“ It’s Full of Gestapo in There”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cake Box")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oleanna")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Shadow")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Devil on a Bicycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1944: Ingrid’s Diaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hijacking")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Through Summer 1944: A Few Beautiful Weeks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1945: The Disguise")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fortress Norway")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February 1945: The Gudbrandsdal Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Potato Spy")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fox and Hen")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unexpected Company")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Knock at the Door")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside Espen’s House")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Night: High Country")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Within Range")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Joke About Chickens")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Checkpoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Draug")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweden")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus for Code Breakers")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Make Your Own Invisible Ink")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/insert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Color Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/timeline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline, 1940–1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/read",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read On!")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0